// frontend/src/components/wizard/StepReview/DataFlowSummary.jsx
import React from 'react';
import { ArrowRightLeft, Database, ArrowRight } from 'lucide-react';
import { useLanguageStore } from '../../../store/useLanguageStore';

export const DataFlowSummary = ({ source, target }) => {
  const { t } = useLanguageStore();

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
      <h3 className="font-bold text-slate-800 flex items-center mb-6">
        <ArrowRightLeft className="w-5 h-5 mr-2 text-indigo-600" /> {t('wizard.review.data_flow.title') || 'Flujo de Datos'}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative">
        <div className="bg-slate-50 border border-slate-100 rounded-xl p-4">
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{t('wizard.review.data_flow.source') || 'Origen'}</span>
          <div className="flex items-center mt-2">
            <Database className="w-6 h-6 text-indigo-500 mr-3" />
            <div>
              <p className="font-bold text-slate-800 uppercase text-sm">{source.type || t('wizard.review.data_flow.na')}</p>
              <p className="text-xs text-slate-500 mt-0.5 truncate max-w-[180px]">{source.config?.selectedTable || source.config?.database || t('wizard.review.data_flow.na')}</p>
            </div>
          </div>
        </div>
        <div className="hidden md:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white border border-slate-200 rounded-full items-center justify-center shadow-sm">
          <ArrowRight className="w-4 h-4 text-slate-400" />
        </div>
        <div className="bg-emerald-50/50 border border-emerald-100 rounded-xl p-4">
          <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-wider">{t('wizard.review.data_flow.target') || 'Destino'}</span>
          <div className="flex items-center mt-2">
            <Database className="w-6 h-6 text-emerald-500 mr-3" />
            <div>
              <p className="font-bold text-slate-800 uppercase text-sm">{target.type || t('wizard.review.data_flow.na')}</p>
              <p className="text-xs text-slate-500 mt-0.5 truncate max-w-[180px]">{target.config?.selectedTable || target.config?.database || t('wizard.review.data_flow.na')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};